export const ACTIVE_REGISTRATION_DISCLAIMER_VERSION = "registration-liability-rf-2026-05-04-v1" as const;

export function isActiveRegistrationDisclaimerVersion(version: string): boolean {
  return version.trim() === ACTIVE_REGISTRATION_DISCLAIMER_VERSION;
}
